import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=b648dc3e&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"
import style0 from "./Dev.vue?vue&type=style&index=0&id=b648dc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b648dc3e",
  null
  
)

export default component.exports